import React from "react";

interface IProps {
    className: string;
    heading: string;
    isCurrentStep?: boolean;
    children?: React.ReactNode;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to trivial render-only container component with no state or logic.
export class CheckoutStepContainer extends React.Component<IProps, IState> {
    render() {
        return (
            <div
                role="group"
                className={`checkout-step ${this.props.className}`}
                aria-label={this.props.heading}
            >
                <h2
                    className="checkout-step__heading"
                    aria-current={this.props.isCurrentStep ? "step" : false}
                >
                    {this.props.heading}
                </h2>
                {this.props.children}
            </div>
        );
    }
}
